import { installBigIntDebug } from "@bridgesplit/utils";

import Routes from "./components/Routes";
import { AppWrapper, Providers } from "./components/wrappers";
import { initMixpanel, initSolanaMobileWallet } from "./hooks";
import { initWebVitals } from "./utils/webVitals";

// initMixpanel must run synchronously — useSetMixpanel calls mixpanel.identify
// as soon as a wallet address is available, which crashes if the client isn't
// initialized yet.
initMixpanel();

// Synchronous so CLS/INP observers attach from t=0; deferring misses early
// shifts/interactions.
initWebVitals();

// Dev-only: make JSON.stringify tolerate bigint so domain objects are loggable.
installBigIntDebug();

// Run after first paint so this doesn't extend the initial long task.
// Safari lacks requestIdleCallback, hence the fallback.
const runWhenIdle = (cb: () => void) => {
    if (typeof window === "undefined") return;
    if ("requestIdleCallback" in window) {
        (window as unknown as { requestIdleCallback: (cb: () => void) => void }).requestIdleCallback(cb);
    } else {
        setTimeout(cb, 200);
    }
};

runWhenIdle(() => {
    initSolanaMobileWallet();
});

export function App() {
    return (
        <Providers>
            <AppWrapper>
                <Routes />
            </AppWrapper>
        </Providers>
    );
}

export default App;
